export default __webpack_public_path__ + "static/media/opensans-bolditalic-webfont.22d8ac48.woff2";